// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 54 hooks for backend/drivers.

import { useBackend } from '../useBackend'

/** POST /api/drivers/blockFromInterviewing */
export function useBlockFromInterviewing<T = any>() {
  return useBackend<T>('drivers/blockFromInterviewing')
}

/** POST /api/drivers/checkCoachingSignatures */
export function useCheckCoachingSignatures<T = any>() {
  return useBackend<T>('drivers/checkCoachingSignatures')
}

/** POST /api/drivers/confirmBankLetter */
export function useConfirmBankLetter<T = any>() {
  return useBackend<T>('drivers/confirmBankLetter')
}

/** POST /api/drivers/decideDrivingCase */
export function useDecideDrivingCase<T = any>() {
  return useBackend<T>('drivers/decideDrivingCase')
}

/** POST /api/drivers/decideFineDispute */
export function useDecideFineDispute<T = any>() {
  return useBackend<T>('drivers/decideFineDispute')
}

/** POST /api/drivers/getAcademyMembers */
export function useGetAcademyMembers<T = any>() {
  return useBackend<T>('drivers/getAcademyMembers')
}

/** POST /api/drivers/getAddressHealth */
export function useGetAddressHealth<T = any>() {
  return useBackend<T>('drivers/getAddressHealth')
}

/** POST /api/drivers/getAgreementSignatures */
export function useGetAgreementSignatures<T = any>() {
  return useBackend<T>('drivers/getAgreementSignatures')
}

/** POST /api/drivers/getCoachingDocumentLink */
export function useGetCoachingDocumentLink<T = any>() {
  return useBackend<T>('drivers/getCoachingDocumentLink')
}

/** POST /api/drivers/getCoachingPreview */
export function useGetCoachingPreview<T = any>() {
  return useBackend<T>('drivers/getCoachingPreview')
}

/** POST /api/drivers/getDriverBankDetails */
export function useGetDriverBankDetails<T = any>() {
  return useBackend<T>('drivers/getDriverBankDetails')
}

/** POST /api/drivers/getDriverCoaching */
export function useGetDriverCoaching<T = any>() {
  return useBackend<T>('drivers/getDriverCoaching')
}

/** POST /api/drivers/getDriverDocumentUrl */
export function useGetDriverDocumentUrl<T = any>() {
  return useBackend<T>('drivers/getDriverDocumentUrl')
}

/** POST /api/drivers/getDriverDocuments */
export function useGetDriverDocuments<T = any>() {
  return useBackend<T>('drivers/getDriverDocuments')
}

/** POST /api/drivers/getDriverDrivingReport */
export function useGetDriverDrivingReport<T = any>() {
  return useBackend<T>('drivers/getDriverDrivingReport')
}

/** POST /api/drivers/getDriverManagerBoard */
export function useGetDriverManagerBoard<T = any>() {
  return useBackend<T>('drivers/getDriverManagerBoard')
}

/** POST /api/drivers/getDriverManagerHistory */
export function useGetDriverManagerHistory<T = any>() {
  return useBackend<T>('drivers/getDriverManagerHistory')
}

/** POST /api/drivers/getDriverProfile */
export function useGetDriverProfile<T = any>() {
  return useBackend<T>('drivers/getDriverProfile')
}

/** POST /api/drivers/getDrivingCase */
export function useGetDrivingCase<T = any>() {
  return useBackend<T>('drivers/getDrivingCase')
}

/** POST /api/drivers/getDrivingConduct */
export function useGetDrivingConduct<T = any>() {
  return useBackend<T>('drivers/getDrivingConduct')
}

/** POST /api/drivers/getDrivingFines */
export function useGetDrivingFines<T = any>() {
  return useBackend<T>('drivers/getDrivingFines')
}

/** POST /api/drivers/getManagerOptions */
export function useGetManagerOptions<T = any>() {
  return useBackend<T>('drivers/getManagerOptions')
}

/** POST /api/drivers/getPipelineStageCounts */
export function useGetPipelineStageCounts<T = any>() {
  return useBackend<T>('drivers/getPipelineStageCounts')
}

/** POST /api/drivers/getPipelineStageList */
export function useGetPipelineStageList<T = any>() {
  return useBackend<T>('drivers/getPipelineStageList')
}

/** POST /api/drivers/importDriverFormDocuments */
export function useImportDriverFormDocuments<T = any>() {
  return useBackend<T>('drivers/importDriverFormDocuments')
}

/** POST /api/drivers/importSignedContract */
export function useImportSignedContract<T = any>() {
  return useBackend<T>('drivers/importSignedContract')
}

/** POST /api/drivers/issueCoachingNote */
export function useIssueCoachingNote<T = any>() {
  return useBackend<T>('drivers/issueCoachingNote')
}

/** POST /api/drivers/liftApplicantBlock */
export function useLiftApplicantBlock<T = any>() {
  return useBackend<T>('drivers/liftApplicantBlock')
}

/** POST /api/drivers/linkRepairToMissedService */
export function useLinkRepairToMissedService<T = any>() {
  return useBackend<T>('drivers/linkRepairToMissedService')
}

/** POST /api/drivers/offerFineConsent */
export function useOfferFineConsent<T = any>() {
  return useBackend<T>('drivers/offerFineConsent')
}

/** POST /api/drivers/overrideDriverDocument */
export function useOverrideDriverDocument<T = any>() {
  return useBackend<T>('drivers/overrideDriverDocument')
}

/** POST /api/drivers/readDriverDocumentAgain */
export function useReadDriverDocumentAgain<T = any>() {
  return useBackend<T>('drivers/readDriverDocumentAgain')
}

/** POST /api/drivers/reconcileDriverManagers */
export function useReconcileDriverManagers<T = any>() {
  return useBackend<T>('drivers/reconcileDriverManagers')
}

/** POST /api/drivers/recordAgreementSignature */
export function useRecordAgreementSignature<T = any>() {
  return useBackend<T>('drivers/recordAgreementSignature')
}

/** POST /api/drivers/recordDrivingCaseNotice */
export function useRecordDrivingCaseNotice<T = any>() {
  return useBackend<T>('drivers/recordDrivingCaseNotice')
}

/** POST /api/drivers/recordDrivingCaseResponse */
export function useRecordDrivingCaseResponse<T = any>() {
  return useBackend<T>('drivers/recordDrivingCaseResponse')
}

/** POST /api/drivers/recordDrivingHearing */
export function useRecordDrivingHearing<T = any>() {
  return useBackend<T>('drivers/recordDrivingHearing')
}

/** POST /api/drivers/recordFineConsent */
export function useRecordFineConsent<T = any>() {
  return useBackend<T>('drivers/recordFineConsent')
}

/** POST /api/drivers/recordFineDispute */
export function useRecordFineDispute<T = any>() {
  return useBackend<T>('drivers/recordFineDispute')
}

/** POST /api/drivers/recordFineNotice */
export function useRecordFineNotice<T = any>() {
  return useBackend<T>('drivers/recordFineNotice')
}

/** POST /api/drivers/recordProfileConsent */
export function useRecordProfileConsent<T = any>() {
  return useBackend<T>('drivers/recordProfileConsent')
}

/** POST /api/drivers/recordServiceInstruction */
export function useRecordServiceInstruction<T = any>() {
  return useBackend<T>('drivers/recordServiceInstruction')
}

/** POST /api/drivers/recordServiceReason */
export function useRecordServiceReason<T = any>() {
  return useBackend<T>('drivers/recordServiceReason')
}

/** POST /api/drivers/remindCoachingSignature */
export function useRemindCoachingSignature<T = any>() {
  return useBackend<T>('drivers/remindCoachingSignature')
}

/** POST /api/drivers/saveCoachingNote */
export function useSaveCoachingNote<T = any>() {
  return useBackend<T>('drivers/saveCoachingNote')
}

/** POST /api/drivers/saveDriverProfile */
export function useSaveDriverProfile<T = any>() {
  return useBackend<T>('drivers/saveDriverProfile')
}

/** POST /api/drivers/setAgreementInForce */
export function useSetAgreementInForce<T = any>() {
  return useBackend<T>('drivers/setAgreementInForce')
}

/** POST /api/drivers/setDriverManager */
export function useSetDriverManager<T = any>() {
  return useBackend<T>('drivers/setDriverManager')
}

/** POST /api/drivers/updateDriverDetails */
export function useUpdateDriverDetails<T = any>() {
  return useBackend<T>('drivers/updateDriverDetails')
}

/** POST /api/drivers/uploadBankLetter */
export function useUploadBankLetter<T = any>() {
  return useBackend<T>('drivers/uploadBankLetter')
}

/** POST /api/drivers/uploadDriverDocument */
export function useUploadDriverDocument<T = any>() {
  return useBackend<T>('drivers/uploadDriverDocument')
}

/** POST /api/drivers/voidCoachingNote */
export function useVoidCoachingNote<T = any>() {
  return useBackend<T>('drivers/voidCoachingNote')
}

/** POST /api/drivers/withdrawAgreementSignature */
export function useWithdrawAgreementSignature<T = any>() {
  return useBackend<T>('drivers/withdrawAgreementSignature')
}

/** POST /api/drivers/withdrawProfileConsent */
export function useWithdrawProfileConsent<T = any>() {
  return useBackend<T>('drivers/withdrawProfileConsent')
}
